<template>
  <div style="display: flex; flex-direction: column; gap: 10px">
    <div class="m-card">
      <div>
        <h2 style="font-weight: bold">Map Tracking</h2>
      </div>
      <l-map style="height: 350px" :zoom="zoom" :center="center">
        <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
        <l-marker :lat-lng="markerLatLng_start" ></l-marker>
        <l-marker :lat-lng="markerLatLng_end" ></l-marker>
        <l-polyline
          :lat-lngs="polygon.latlngs"
          :color="polygon.color"
        ></l-polyline>
      </l-map>
    </div>
    <div class="layout-card" v-if="items_box != undefined">
      <div class="m-card" style="" v-for="(item, i) in items_box.data" :key="i">
        <div style="display: flex; justify-content: space-between">
          <div>{{ i }}</div>
          <div style="color: var(--text-color-2)">
            {{ items_box.timestamp }}
          </div>
        </div>
        <div style="display: flex; justify-content: flex-end">
          <div>{{ item }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LMap, LTileLayer, LPolyline,LMarker } from "vue2-leaflet";

export default {
  components: {
    LMap,
    LTileLayer,
    LPolyline,
    LMarker,
  },
  data() {
    return {
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 15,
      center: [13.8116717, 100.5650815],
      markerLatLng_start: [47.313220, -1.319482],
      markerLatLng_end: [47.313220, -1.319482],
      polygon: {
        latlngs: [
          [13.8116717, 100.5650815],
          [13.8109402, 100.565086],
          [13.810245, 100.5662938],
          [13.809565, 100.5677627],
          [13.8089276, 100.5692138],
          [13.8080325, 100.5707993],
          [13.8067298, 100.5727419],
          [13.8063724, 100.5737888],
          [13.80579, 100.5746888],
          [13.8063724, 100.5747888],
          [13.8076797, 100.5748588],
          [13.8098091, 100.5748587],
        ],
        color: "green",
      },
      items_box: undefined,
      timeout: null,
    };
  },
  async mounted() {
     this.getGPS();
     this.getGPSLog();
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
  methods: {
    async getGPS() {
      try {
        let res = await this.$API.get("gps/current");
        console.log("GPS", res);
        this.items_box = res.data;
        this.timeout = setTimeout(async () => {
          await this.getGPS();
        }, 1000 * 10);
      } catch (error) {}
    },
    async getGPSLog() {
      try {
        let res = await this.$API.get("gps/2days");
        console.log("GPS log", res.data);
        this.polygon.latlngs = [];
        let lati_b =0
        let long_b = 0
        for (let i = 0; i < res.data.length; i++) {
          const el = res.data[i];
          const lat = res.data[i];
          const long = res.data[i];
          if (el.data["position.latitude"] != undefined) {
            if (lati_b == 0) {
              this.polygon.latlngs.push([
                el.data["position.latitude"],
                el.data["position.longitude"],
              ]);
              lati_b = el.data["position.latitude"]
              long_b = el.data["position.longitude"]
            }
            let lati_abs = Math.abs(lati_b - el.data["position.latitude"])
            let long_abs = Math.abs(long_b - el.data["position.longitude"])
            console.log(lati_abs,long_abs);
            if (lati_abs > 0.0008 || long_abs > 0.0008) {
              this.polygon.latlngs.push([
                el.data["position.latitude"],
                el.data["position.longitude"],
              ]);
            }
            

          }
        }
        this.markerLatLng_start = this.polygon.latlngs[0]
        this.markerLatLng_end = this.polygon.latlngs[this.polygon.latlngs.length-1]

        this.center = this.polygon.latlngs[this.polygon.latlngs.length-1]
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped>
.layout-card {
  display: grid;
  grid-template-columns: auto auto auto auto;
  gap: 10px;
}
</style>